import { Grid, Typography, Box, makeStyles } from "@material-ui/core";

import { PowerAssetIcon } from "../../PowerAssetIcon";
import { capitalize } from "../../../../services/utils";
import { DialogBox } from "../../../../components/boxes";
import RemoveIcon from "../../../../assets/images/icons/remove.svg";
import SignatureIcon from "../../../../assets/images/icons/signature.svg";
import {
  Icon,
  Button,
  TextButton,
  TextAreaInput,
  Dialog,
} from "../../../../components/base";
import { COLORS } from "../../../../theme/colors";

const useStyles = makeStyles(() => ({
  approvedData: {
    "&:not(:last-child)": {
      marginBottom: 20,
    },
  },
  signatureIcon: {
    position: "absolute",
    bottom: "-10px",
  },
  signature: {
    borderBottom: "1px solid #000",
    paddingLeft: 15,
    paddingBottom: 5,
    width: "300px",
    marginLeft: 20,
    marginTop: 30,
    cursor: "pointer",
  },
  signatureText: {
    color: COLORS.darks[0][50],
    fontStyle: "italic",
  },
}));

export const NewPowerAssetsApprovalModal = ({
  approveData,
  isOpen,
  setOpen,
  setOpenSuccessModal,
}) => {
  const classes = useStyles();

  const handleClick = () => {
    setOpen(false);
    setOpenSuccessModal(true);
  };

  return (
    <Dialog isOpen={isOpen} onClose={() => setOpen(false)}>
      <DialogBox>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          style={{ marginBottom: 34 }}
        >
          <Typography variant="h2" style={{ fontWeight: 700 }}>
            New Power Asset Approval
          </Typography>
          <Icon
            hoverable={true}
            onClick={() => setOpen(false)}
            src={RemoveIcon}
          />
        </Grid>
        <Typography variant="h4" style={{ marginBottom: 30 }}>
          Read and sign the terms sheet below in order to approve the following
          new power assets:
        </Typography>
        {approveData.map((item) => (
          <Grid
            key={item.id}
            container
            alignItems="center"
            className={classes.approvedData}
          >
            <PowerAssetIcon type={item.type.toLowerCase()} />
            <Box>
              <Typography variant="h4" style={{ fontWeight: 700 }}>
                {capitalize(item.type)}
              </Typography>
              <Typography variant="subtitle2">{item.location}</Typography>
            </Box>
          </Grid>
        ))}
        <Typography
          variant="body1"
          style={{ marginBottom: 10, fontWeight: 700 }}
        >
          Terms sheet
        </Typography>
        <TextAreaInput value="Terms sheet details come here." />
        <Box>
          <Box
            sx={{ display: "flex", alignItems: "center", position: "relative" }}
          >
            <Box className={classes.signatureIcon}>
              <Icon src={SignatureIcon} />
            </Box>
            <Box className={classes.signature}>
              <Typography variant="body1" className={classes.signatureText}>
                Tap here to add your signature
              </Typography>
            </Box>
          </Box>
        </Box>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          style={{ marginTop: 50 }}
        >
          <Button
            text="order implementation plan"
            onClick={() => handleClick()}
          />
          <TextButton text="DOWNLOAD TERMS SHEET" />
          <TextButton text="CANCEL" onClick={() => setOpen(false)} />
        </Grid>
      </DialogBox>
    </Dialog>
  );
};
